import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { Organization } from '../Organization.js';
import { MollieProfile } from '../OrganizationPrivateMetaData.js';
export class CheckMollieResponse extends AutoEncoder {
    profiles = [];
    organization;
}
__decorate([
    field({ decoder: new ArrayDecoder(MollieProfile) })
], CheckMollieResponse.prototype, "profiles", void 0);
__decorate([
    field({ decoder: Organization })
], CheckMollieResponse.prototype, "organization", void 0);
//# sourceMappingURL=CheckMollieResponse.js.map